"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedInvoiceResponseWithCount = exports.mockedInvoiceWithoutCartResponse = exports.mockedInvoiceResponse = exports.invoiceCreateOrUpdateMockResponse = exports.invoiceCreateOrUpdateMockRequest = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const date_util_1 = require("../../utils/date.util");
const omit_util_1 = require("../../utils/omit.util");
const cart_item_1 = require("../cart-item");
const invoice_allowed_payment_provider_1 = require("../invoice-allowed-payment-provider");
const invoice_payer_1 = require("../invoice-payer");
const participant_1 = require("../participant");
exports.invoiceCreateOrUpdateMockRequest = {
  participant: participant_1.mockedParticipantCreateOrUpdateRequest,
  payer: invoice_payer_1.mockedInvoicePayerCreatOrUpdate,
  sellerId: 1,
  amoLeadId: '123123',
  comment: 'invoice comment',
  allowedPaymentProviderIds: [invoice_allowed_payment_provider_1.mockedInvoiceAllowedPaymentProviderCreateRequest],
  cart: [{
    productId: 1,
    quantity: 1,
    type: common_interfaces_1.ProductType.material,
    item: {}
  }]
};
exports.invoiceCreateOrUpdateMockResponse = Object.assign(Object.assign({}, exports.invoiceCreateOrUpdateMockRequest), {
  amoLeadId: '123123',
  paymentProviderIds: [1, 2],
  comment: '',
  cart: []
});
exports.mockedInvoiceResponse = {
  id: 1,
  amoLeadId: '123123',
  participant: participant_1.mockedParticipantResponse,
  payer: invoice_payer_1.mockedInvoicePayerResponse,
  comment: '',
  uid: '123123123123123',
  seller: null,
  cart: [cart_item_1.mockedCartItemResponse],
  payment: null,
  discounts: [],
  allowedPaymentProviders: [invoice_allowed_payment_provider_1.mockedInvoiceAllowedPaymentProviderResponse],
  formScenario: null,
  createdAt: date_util_1.takeDaysFromNow(),
  updatedAt: null,
  oldId: null
};
exports.mockedInvoiceWithoutCartResponse = omit_util_1.omitObject(exports.mockedInvoiceResponse, 'cart');
exports.mockedInvoiceResponseWithCount = {
  items: [exports.mockedInvoiceResponse],
  count: 1
};